import React, { useState } from "react";

import ActionBar from "../actionBar/actionBar.component";
import AlertPanel from "../alertPanel/alertPanel.component";
import BookmarkIcon from "../../icons/bookmarkIcon.component";
import ExternalLinkIcon from "../../../assets/icons/external_link.svg";
import useContestSettings from "../../../hooks/useContestSettings";
import useAppContext from "../../../hooks/useAppContext";

import { StyledWrapper } from "./details.style";

const Details = () => {
  const { data, eligibility, eligibilityReason } = useContestSettings();
  const { axios } = useAppContext();

  const [bookmarkStatus, setBookmarkStatus] = useState(data.bookmarkStatus);

  const addToDojoClick = () => {
    if (data.addToDojoPath) {
      axios
        .post(data.addToDojoPath)
        .then((res) => {
          if (res.data.data.id) {
            setBookmarkStatus(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <StyledWrapper className="row p-0">
      <div className={`col-12 contest-status-${data.status}`}>
        <div className="row">
          <div className="col-12 col-md-6 order-md-2 mb-4">
            <div className="contest-image">
              <img src={data.snapshotPicUrl} alt="Contest Image" />
              {data.linkToVideo && (
                <a
                  href={data.linkToVideo}
                  className="contest-image-video-icon"
                  data-fancybox="mindsumo_video"
                >
                  <span className="fa-stack fa-3x">
                    <i className="fa fa-circle-thin fa-stack-2x"></i>
                    <i className="fa fa-play fa-stack-1x"></i>
                  </span>
                  <div className="contest-image-text">
                    Press play to view the Challenge video!
                  </div>
                </a>
              )}
              {eligibility &&
                (bookmarkStatus ? (
                  <div className="contest-bookmark-image-icon m-3 p-2 rounded-circle">
                    <BookmarkIcon size={24} state={true} />
                  </div>
                ) : (
                  !data.solvingTimeLimit &&
                  data.addToDojoPath && (
                    <button
                      className="contest-bookmark-image-icon enabled m-3 p-2 rounded-circle"
                      onClick={addToDojoClick}
                    >
                      <BookmarkIcon size={24} state={false} />
                    </button>
                  )
                ))}
            </div>
          </div>

          <div className="col-12 col-md-6 order-md-1 my-4">
            <div className="contest-status">
              <div className="contest-status-badge badge px-2 px-xl-3 py-1">
                {data.statusTitleized}
              </div>
            </div>

            <div className="contest-company mt-3 py-1">
              {data.company.logoImg && (
                <span className="contest-company-logo me-2">
                  <img src={data.company.logoImg.tinyPic.url} />
                </span>
              )}
              <span className="contest-company-name">
                {data.company.displayName}
              </span>
              <span className="mx-1">&bull;</span>
              <span className="contest-deadline">
                Closes {data.deadlineDate}
              </span>
            </div>

            <div className="contest-title mt-3">{data.title}</div>

            <div
              className="contest-short-description mt-3"
              dangerouslySetInnerHTML={{ __html: data.shortDescription }}
            ></div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <hr className="contest-divider my-3 my-md-4" />
          </div>

          <div className="col-12">
            <ActionBar sticky={true} offset={50} />
          </div>

          <div className="col-12">
            <div
              id="Description"
              className="contest-heading mb-3 mt-5"
              data-anchor="Description"
            >
              Description
            </div>
            <div
              className="contest-description"
              dangerouslySetInnerHTML={{ __html: data.description }}
            ></div>

            {eligibility ? (
              <>
                <div id="Deliverables" data-anchor="Deliverables">
                  <div className="contest-heading mb-3 mt-5">Deliverables</div>
                  {data.requirement ? (
                    <div
                      className="contest-deliverables"
                      dangerouslySetInnerHTML={{ __html: data.requirement }}
                    ></div>
                  ) : (
                    data.deliverableSubmissionFields.map((item, index) => (
                      <div
                        className="contest-deliverables mb-4"
                        key={index}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      ></div>
                    ))
                  )}
                </div>
                {data.files && data.files.length > 0 && (
                  <div
                    id="AdditionalMaterials"
                    data-anchor="Additional Materials"
                  >
                    <div className="contest-heading mb-3 mt-5">
                      Additional Materials
                    </div>
                    <div className="contest-materials">
                      {data.files.map((item, index) => (
                        <div className="mt-2" key={index}>
                          <a href={item.s3Url} target="_blank" rel="noreferrer">
                            {item.displayName} <img src={ExternalLinkIcon} />
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {data.showCriteria && data.criteriaList && (
                  <>
                    <div id="Criteria" data-anchor="Criteria">
                      <div className="contest-heading mb-3 mt-5">
                        Evaluation Criteria
                      </div>
                      <div className="contest-criteria">
                        <div>
                          All eligible submissions will be graded using the
                          following criteria:
                        </div>
                        <ul className="mb-0 mt-3">
                          {data.criteriaList.map((item, index) => (
                            <li className="mt-2" key={index}>
                              {item}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    {data.multiple_solution_count > 1 && (
                      <div>
                        <b>
                          You can submit up to {data.multiple_solution_count}{" "}
                          times for this challenge.
                        </b>
                      </div>
                    )}
                  </>
                )}
              </>
            ) : (
              <AlertPanel message={eligibilityReason} />
            )}
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

export default Details;
